
class IntegratorMappingDetailCell extends UITableViewCell
{
    private sourceTextField: MUITextField = null;
    private keyTextField: MUITextField = null;

    awakeFromHTML() {
        this.sourceTextField = MUIOutlet(this, "source-tf", "MUITextField");
        this.sourceTextField.setOnChangeText(this, function(tf: MUITextField, value: string) {
            this._item.sourceKey = value;
        });

        this.keyTextField = MUIOutlet(this, "key-tf", "MUITextField");
        this.keyTextField.setOnChangeText(this, function(tf: MUITextField, value: string) {
            this._item.targetKey = value;
        });

        this.selectionStyle = UITableViewCellSelectionStyle.None;
    }

    private _item: IntegratorMappingKey = null;
    set item(item: IntegratorMappingKey) {
        this._item = item;
        this.sourceTextField.text = item.sourceKey;
        this.keyTextField.text = item.targetKey;
    }
}
